const e = {
  primary: "primary",
  secondary: "secondary",
  error: "error",
  neutral: "neutral"
}, r = {
  default: "default",
  "inverse-default": "inverse-default",
  stronger: "stronger",
  strongest: "strongest",
  weak: "weak",
  weaker: "weaker",
  weakest: "weakest",
  weakest2: "weakest2",
  weakest3: "weakest3"
}, t = {
  default: "default",
  light: "light",
  accent: "accent"
}, a = {
  error: "error",
  bg: "bg",
  fg: "fg",
  info: "info",
  success: "success",
  warning: "warning"
};
export {
  e as BUTTON_COLOR,
  r as COLOR_EMPHASIS,
  t as LINK_BUTTON_COLOR,
  a as SEMANTICS_COLOR
};
//# sourceMappingURL=color.es.js.map
